import { prepareLabels } from './prepareLabels';
import { prepareGeo } from './prepareGeo';
import { prepareDailyRating } from './prepareDailyRating';
import { preparePrice } from './preparePrice';
import { prepareSubtitle } from './prepareSubtitle';
import { prepareTitle } from './prepareTitle';
import { IOfferCard } from '../../../../types';

export const prepareGeneralInfo = (offerCard: IOfferCard) => ({
  title: prepareTitle(offerCard),
  subtitle: prepareSubtitle(offerCard),
  labels: prepareLabels(offerCard),
  geo: prepareGeo(offerCard),
  dailyRating: prepareDailyRating(offerCard),
  description: offerCard.description,
  price: preparePrice(offerCard),
});
